import React, { useState, useEffect, useRef } from 'react';
import { saveAs } from 'file-saver';
import { utils, write } from 'xlsx';
import 'bootstrap/dist/css/bootstrap.min.css';
import $ from 'jquery';
import 'datatables.net-buttons-dt/css/buttons.dataTables.min.css';
import 'datatables.net';
import 'datatables.net-buttons/js/dataTables.buttons';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import '../../../App.css';

const Table = ({ selectedMonth }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 1000; // Number of items per page
  const tableRef = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false); // State to manage dropdown visibility

  useEffect(() => {
    fetchData(selectedMonth, currentPage);
  }, [selectedMonth, currentPage]);

  const fetchData = async (month, page) => {
    setLoading(true);

    try {
      const url = 'https://zingapi.beeinnovations.com/boxoffice_app/consumer_detailsbkplimit.php';
      const requestData = { month, page };
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const jsonData = await response.json();
      setData(jsonData.consumer_details);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (data.length > 0) {
      const table = $(tableRef.current).DataTable({
        dom: 'lBfrtip',
        buttons: [
          'copy',
          'csv',
          {
            text: 'Excel',
            action: exportToExcel,
          },
          'pdf',
        ],
        bPaginate: true,
        searching: false,
        info: false,
        data: data,
        columns: [
          { data: 'date', title: 'Date' },
          { data: 'msisdn', title: 'MSISDN' },
          { data: 'RV', title: 'STV-PV' },
          { data: 'rechargedate', title: 'Recharge Date' },
          { data: 'circle', title: 'Circle' },
        ],
      });

      return () => table.destroy();
    }
  }, [data]);

  const exportToExcel = () => {
    const excelData = data.map((item) => ({
      Date: item.date,
      MSISDN: item.msisdn,
      RV: item.RV,
      'Recharge Date': item.rechargedate,
      Circle: item.circle,
    }));

    const worksheet = utils.json_to_sheet(excelData);
    const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer = write(workbook, { bookType: 'xlsx', type: 'array' });

    try {
      const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
      saveAs(blob, 'export.xlsx');
    } catch (error) {
      console.error('Error exporting Excel:', error);
    }
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const getFormattedMonth = (month) => {
    const date = new Date(month + '-01');
    return date.toLocaleString('default', { month: 'long', year: 'numeric' });
  };

  const renderPageInfo = () => {
    const totalEntries = data.length;
    const startItem = (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage);
    return `Showing ${startItem} to ${endItem}  Pages `;
  };

  const handleCsvDownload = (url) => {
    if (url) {
      window.location.href = url;
    }
  };
  const handleDropdownToggle = () => {
    setShowDropdown(!showDropdown);
  };
  return (
    <div className="container-fluid">
      <div className="row mt-3">
        <div className="col-12">
          <div className="my-2">
            <center>
              <h6 className="sai_responsive_name">User Detail Report</h6>
            </center>
          </div>

          <div className="row my-2">
          <div className="tabledesign_row ">
              <div className='col-lg-6 col-md-6 col-sm-6'>
                <button className='newonbtn' data-toggle='modal' data-target='#selectPeriodModal'>
                  Select Month
                </button>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6">
                {/* Single button to toggle dropdown */}
                <button className="newonbtn mb-2" onClick={handleDropdownToggle}>
                  Download Reports
                </button>

                {/* Dropdown menu */}
                {showDropdown && (
                  <div className="dropdown-menu" style={{ display: 'block' }}>
                     <button className="dropdown-item" onClick={() => handleCsvDownload('https://cms2024.s3.ap-south-1.amazonaws.com/2024-07.zip')}>
                      July' 24 Reports
                    </button>
                    <button className="dropdown-item" onClick={() => handleCsvDownload('https://cms2024.s3.ap-south-1.amazonaws.com/2024-06.zip')}>
                      June' 24 Reports
                    </button>
                    <button className="dropdown-item" onClick={() => handleCsvDownload('https://cms2024.s3.ap-south-1.amazonaws.com/2024-05.zip')}>
                      May' 24 Reports
                    </button>
                    <button className="dropdown-item" onClick={() => handleCsvDownload('https://cms2024.s3.ap-south-1.amazonaws.com/2024-04.zip')}>
                      April' 24 Reports
                    </button>
                   
                 
                   
                  </div>
                )}
              </div>
            </div>
          </div>

          {loading ? (
            <div className="text-center mt-3">
              <p>Loading data ...</p>
            </div>
          ) : (
            <>
              <div className="table-responsive">
                <table className="table" ref={tableRef}>
                  <thead className="table-head table_head_desgin" style={{ background: '#F5EFFF !important' }}>
                    <tr>
                      <th>Date</th>
                      <th>MSISDN</th>
                      <th>RV</th>
                      <th>Recharge Date</th>
                      <th>Circle</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, index) => (
                      <tr key={index}>
                        <td>{item.date}</td>
                        <td>{item.msisdn}</td>
                        <td>{item.RV}</td>
                        <td>{item.rechargedate}</td>
                        <td>{item.circle}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="row mt-3">
                <div className="col">
                  <center>                   <p>{renderPageInfo()}</p>
                  </center>
                </div>
              </div>



              <div className="row">
                <div className="col d-flex justify-content-center">
                  <nav aria-label="Page navigation example">
                    <ul className="pagination" style={{margin:'2px 0px !important'}}>
                      <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={() => handlePageClick(currentPage - 1)}>Previous</button>
                      </li>
                      <li className="page-item">
                        <button className="page-link" onClick={() => handlePageClick(currentPage + 1)}>Next</button>
                      </li>
                    </ul>
                  </nav>
                </div>
                <center className=''>
                    <p>For Month {getFormattedMonth(selectedMonth)}</p>
                  </center>
              </div>
            </>
          )}
        </div>
    
      </div>
    </div>
  );
};

export default Table;
